/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyOutput
 */
export interface MoneyOutput {
    /**
     * 
     * @type {string}
     * @memberof MoneyOutput
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof MoneyOutput
     */
    currency?: string;
}

/**
 * Check if a given object implements the MoneyOutput interface.
 */
export function instanceOfMoneyOutput(value: object): value is MoneyOutput {
    return true;
}

export function MoneyOutputFromJSON(json: any): MoneyOutput {
    return MoneyOutputFromJSONTyped(json, false);
}

export function MoneyOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
    };
}

export function MoneyOutputToJSON(json: any): MoneyOutput {
    return MoneyOutputToJSONTyped(json, false);
}

export function MoneyOutputToJSONTyped(value?: MoneyOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'currency': value['currency'],
    };
}

